import React, { ButtonHTMLAttributes } from 'react';
import classNames from 'classnames';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
}

export const ButtonSquare: React.FC<ButtonProps> = ({
  children,
  variant = 'primary',
  className,
  disabled,
  ...props
}) => {
  return (
    <button
      className={classNames(
        'button-square',
        variant,
        className
      )}
      disabled={disabled}
      {...props}
    >
        {children}
    </button>
  );
};
